import { Navbar } from 'react-bootstrap'

export default function Logo() {
  return (
    <Navbar.Brand>
      <a href="/"><img src="/logo-light.svg" width="160" alt="Molecule Logo" /></a>
    </Navbar.Brand>
  )
}
